import { getUserData } from "../../utils/common";
import { authorizeToken } from "../../api/emailTriage";

interface LoginAzurePayload {
  sourceId: string;
  service: string;
  identity_action: string;
  app_id: string;
  redirect_uri: string;
  user_id: string;
  user_role: string;
  user_email: string;
  user_name: string;
}

interface ILoginAzure {
  service: string,
  sourceId: string,
  isReLogin?: boolean,
}

const loginAzure = ({ service, sourceId, isReLogin }: ILoginAzure) => {
  const { id, role, email, name } = getUserData()
  const payload: LoginAzurePayload = {
    sourceId: sourceId,
    service: service,
    identity_action: 'login',
    app_id: process.env.REACT_APP_PHISH_FOCUS_AZURE_APP_ID as string,
    redirect_uri: window.location.origin,
    user_id: id,
    user_role: role,
    user_email: email,
    user_name: name,
  };

  sessionStorage.setItem("auth_route", JSON.stringify({
    service,
    id: sourceId
  }));

  sessionStorage.setItem("login_type", isReLogin ? 're_login' : 'login')

  authorizeToken(payload).then((response) => {
    console.log('LoginAzure response', response)
    window.open(
      response.data.authorization_url,
      '_self', 'noopener,noreferrer'
    )
  }).catch(e => {
    console.log(e);
  });
};

export default loginAzure;